import React from "react";
import IncSitesList from "./inc_sites";

// Container for the sites assigned to the current user — the ones they are on
// the team of. Sites they merely created are not listed here; those are under
// INC Sites, which is project-wise.
const MyIncSitesPage: React.FC = () => {
  return <IncSitesList endpoint="/inc/sites" title="My INC Sites" />;
};

export default MyIncSitesPage;
